import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

import useChatDropDown from './useChatDropdown';

import { IoIosArrowDown, IoMdCheckmark } from 'react-icons/io';

import { OTooltip } from '@src/shared';

import './chatDropdown.scss';

const ChatDropdown = () => {
  const {
    handleClick,
    selectedChatName,
    anchorEl,
    handleClose,
    setSearch,
    filteredChats,
    handleSelectChat,
    selectedReceiverData,
    messagesNotifications,
    search,
    open,
  } = useChatDropDown();

  return (
    <div>
      {/* Dropdown Button */}
      <OTooltip title="Select recipient (Public/Private)">
        <Box component="button" onClick={handleClick} className="dropdown-button">
          <Typography className="peer-name-selected">{selectedChatName}</Typography>
          <div className="arrow-down">
            <IoIosArrowDown />
          </div>
        </Box>
      </OTooltip>

      {/* Popover for Dropdown */}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          className: 'custom-popover',
        }}
      >
        {/* Search Bar */}

        <MenuItem disableRipple className="custom-menu-item">
          <TextField
            variant="outlined"
            placeholder="Search by name"
            fullWidth
            size="small"
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            autoFocus
            className="custom-text-field"
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--textarea-border-color)',
                },
              },
            }}
          />
        </MenuItem>

        <div className="scrollable-peer">
          <List className="list-peer">
            {filteredChats.length > 0 ? (
              filteredChats.map(({ id, name, type }) => (
                <OTooltip key={id} placement="left" title={name === 'Public chat' ? '' : `Chat with ${name} privately`}>
                  <ListItem key={id} onClick={() => handleSelectChat({ id, type })} className="custom-list-item">
                    <Typography className={`peer-name ${id === selectedReceiverData.value ? 'active-item' : ''}`}>
                      {name}
                    </Typography>

                    {!!messagesNotifications.get(id)?.length && (
                      <div className="notification-indicator">{messagesNotifications.get(id)!.length}</div>
                    )}
                    {id === selectedReceiverData.value && <IoMdCheckmark color="#00ACFB" size={20} fontWeight="bold" />}
                  </ListItem>
                </OTooltip>
              ))
            ) : (
              <Typography className="text-noresult" component="p">
                No results found
              </Typography>
            )}
          </List>
        </div>
      </Popover>
    </div>
  );
};

export default ChatDropdown;
